import { assetUrl } from '@Shared/Helpers/Utilities';

export const HEADER = [
    {
        title: __('Our Software'),
        value: 'software',
        route: route('web.pages.our_software'),
    },
    {
        title: __('Integrations'),
        value: 'integrations',
        hasMenu: true,
    },
    {
        title: __('Pricing'),
        value: 'pricing',
        hasMenu: false,
        route: route('web.pages.pricing'),
    },
    {
        title: __('Tools & Resources'),
        value: 'resources',
        hasMenu: true,
    },
    {
        title: __('For Affiliates'),
        value: 'affiliates',
        hasMenu: false,
        route: route('web.campaigns.index'),
    },
];

export const HEADER_MENUS = {
    integrations: {
        imgPath: assetUrl('/assets/images/webp/web/header/integrations.webp'),
        content: [
            {
                menuTitle: 'INTEGRATIONS',
                items: [
                    {
                        title: 'All',
                        text: 'Browse all integrations',
                        href: route('web.integrations.index'),
                    },
                    {
                        title: 'Rewards',
                        text: 'Boost referrals with rewards and incentives',
                        href: route('web.pages.rewards'),
                    },
                    {
                        title: 'HubSpot',
                        text: 'Automations with HubSpot',
                        href: route('web.integrations.hubspot'),
                    },
                    {
                        title: 'Stripe',
                        text: 'Automations with Stripe',
                        href: route('web.integrations.stripe'),
                    },
                    {
                        title: 'Salesforce',
                        text: 'Automations with Salesforce',
                        href: route('web.integrations.salesforce'),
                    },
                    {
                        title: 'Intercom',
                        text: 'Automations with Intercom',
                        href: route('web.integrations.intercom'),
                    },
                    {
                        title: 'Monday.com',
                        text: 'Automations with Monday.com',
                        href: route('web.integrations.monday'),
                    },
                    {
                        title: 'Webhooks and API',
                        text: 'Flexible API and webhook abilities',
                        href: route('web.integrations.webhook-api'),
                    },
                    {
                        title: 'Zoho',
                        text: 'Automations with Zoho',
                        href: route('web.integrations.zoho'),
                    },
                    {
                        title: 'Zapier',
                        text: 'Automations with Zapier',
                        href: route('web.integrations.zapier'),
                    },
                    {
                        title: 'Pipedrive',
                        text: 'Automations with Pipedrive',
                        href: route('web.integrations.pipedrive'),
                    },
                    {
                        title: 'ServiceTitan',
                        text: 'Automations with ServiceTitan',
                        href: route('web.integrations.servicetitan'),
                    },
                    {
                        title: 'Make.com',
                        text: 'Automations with Make.com',
                        href: route('web.integrations.make'),
                    },
                ],
            },
        ],
    },
    resources: {
        imgPath: assetUrl('/assets/images/webp/web/header/tools.webp'),
        content: [
            {
                menuTitle: 'TOOLS',
                items: [
                    {
                        title: 'Estimate your ROI',
                        text: 'Calculate how many referrals you’ll get ',
                        href: route('web.pages.calculator'),
                    },
                    {
                        title: 'Referral program examples',
                        text: 'Learn from real world examples',
                        href: route('web.pages.campaign_examples'),
                    },
                    {
                        title: 'Referral link generator',
                        text: 'Create referral links in one click',
                        href: route('web.pages.create-a-referral-program'),
                    },
                    {
                        title: 'Templates',
                        text: 'Ready-to-go referral programs',
                        href: route('web.templates.index'),
                    },
                ],
            },
            {
                menuTitle: 'RESOURCES',
                items: [
                    {
                        title: 'Read our blog',
                        text: 'Learn about referral marketing',
                        href: 'https://referral-factory.com/learn',
                        isExternal: true,
                    },
                    {
                        title: 'Case studies',
                        text: 'Success stories from every industry',
                        href: route('web.pages.success_stories'),
                    },
                    {
                        title: 'Best referral programs to earn',
                        text: 'View our marketplace of public referral programs',
                        href: route('web.campaigns.index'),
                    },
                ],
            },
        ],
    },
};

export const MOBILE_HEADER = [
    {
        title: __('Our Software'),
        value: 'software',
        hasMenu: false,
        route: route('web.pages.our_software'),
    },
    {
        title: __('Integrations'),
        value: 'integrations',
        hasMenu: false,
        route: route('web.integrations.index'),
    },
    {
        title: __('Pricing'),
        value: 'pricing',
        hasMenu: false,
        route: route('web.pages.pricing'),
    },
    {
        title: __('Estimate your ROI'),
        value: 'calculator',
        hasMenu: false,
        route: route('web.pages.calculator'),
    },
    {
        title: __('Read our blog'),
        value: '',
        hasMenu: false,
        externalLink: 'https://referral-factory.com/learn',
    },
    {
        title: __('Get a demo'),
        value: 'demo',
        hasMenu: false,
        route: route('web.pages.demo'),
    },
    {
        title: __('For Affiliates'),
        value: 'affiliates',
        hasMenu: false,
        route: route('web.campaigns.index'),
    },
];
